import TODO from "./TODO.js";
import {PERSISTENCE,U,L,UTIL} from "./util.js";
import {list_media_devices,get_configured_media,CAMERA,MEDIA} from "./mediautil.js";
import each from 'async-es/each';
import eachSeries from 'async-es/eachSeries';
import {PEER} from './peer.js';
import {BANDWIDTH} from './sender.js';
import { STATS } from "./stats.js";
import STRINGS from "./strings.js";
import {C2GSOCKET} from "./c2gsock.js";

export const GUIUTIL = {
 screens: ['loadingScreen','welcomeScreen','mainScreen'],
 show_screen: function show_screen(id) {
  if(this.screens.indexOf(id)<0)
   return L.error({screen:id},"trying to show an unknown screen");
  $('#localVideo_userControls,#sidebar,#tot-stats-panel')
   .css('display', (id=='mainScreen')?'block':'none');
  $('#bodycontainer').show();
  $(this.screens.filter(x=>(x!=id)).map(x=>('#'+x)).join(',')).css('display','none');
  $('#'+id).css('display','block');
 },

 alertypes: {
  success: { aclass: 'success', title: 'Success!' },
  info: { aclass: 'success', title: 'Info!' },
  warn: { aclass: 'warning', title: 'Warning!' },
  error: { aclass: 'danger', title: 'Error!' }
 },
 alert: function alert(type,message) {
  // TODO: have to add this log, because it looks like many alerts are
  // server-relevant, even success ones. At the moment.
  L.warn({type,message},`Alerting user`);
  const atd = this.alertypes[type];
  if(!atd) L.error({type,message},"Unknown alert type");
  else {
   /* TODO: doesn't belong to code */
   const x = $('#overLayerX').html(`
    <div id="alert_${atd.aclass}" class="alert alert-${atd.aclass} alert-dismissible">
     <div class="alert_close close" data-dismiss="alert" aria-label="close">&times;</div>
     <strong>${atd.title}</br></strong>
     ${message}
    </div>
   `);
   $('#overLayer').fadeIn();
   $('.alert_close',x).on('click',function() {
    $('#overLayer').fadeOut();
   });
  }
 },

 fullscreen: function fullscreen(element) {
  const rf = element.requestFullscreen
             || element.mozRequestFullScreen
             || element.webkitRequestFullScreen
             || element.msRequestFullscreen;
  if(rf) rf.call(element);
 },
 handle_exit_fullscreen: function handle_exit_fullscreen(exitHandler) {
  if(document.addEventListener) {
   document.addEventListener('webkitfullscreenchange', exitHandler, false);
   document.addEventListener('mozfullscreenchange', exitHandler, false);
   document.addEventListener('fullscreenchange', exitHandler, false);
   document.addEventListener('MSFullscreenChange', exitHandler, false);
  }
 },

 /* pp: { uid:, text:, buttons: (bool), timeout:, cb: } */
 notify: function notify(pp) {
  const $content = $(`<div class="notification namePopup wtgnotify-${pp.uid}" />`).text(pp.text);
  let timer;
  function _cb(accept) {
   $content.fadeOut((pp.timeout||50000),()=>$content.remove());
   timer&&clearTimeout(timer);
   timer=setTimeout(()=>(pp.cb && pp.cb(Object.assign(pp,{accept}))),pp.timeout||50000);
  }
  if(pp.buttons) {
   $content.append(
    $('<button class="roundedButton"><i class="glyphicon glyphicon-ok"/></button>').on('click',_cb.bind(null,true)),
    $('<button class="roundedButton"><i class="glyphicon glyphicon-remove"/></button>').on('click',_cb.bind(null,false))
   );
   $('#myAudio').trigger('play');
  }
  $content.appendTo($('#notification-container')).fadeIn();
  _cb(false);
 }

};

export function openTextChatArea() {
 $("#btn_text_chat").toggleClass("wtg-green");
 $("#btn_text_chat").toggleClass("wtg-red");
 $('#sidebar').toggleClass('active');
 var current = document.getElementsByClassName("active");
 let tooltip = STRINGS[TODO.tips.btn_text_chat[+(current.length > 0)]];
 $("#btn_text_chat").attr('title', tooltip).tooltip('fixTitle').tooltip('show');
 $("#btn_text_chat").removeClass("glow");
 $("#btn_more").removeClass("glow");
 if($("#sidebar").css('marginRight')=="-250px")
  setTimeout(function(){
   $("#txt_chat_message").focus();
  },400);
}

function audio_animation(s) {
 var actx = window.AudioContext || window.webkitAudioContext;
 if(audioContext) audioContext.close().then(function() {
  audioContext=null;
 });
 audioContext = new actx();
 if(!audioContext) return L.warn("Sorry , failed to read audio stream");
 var mediaStreamSource = audioContext.createMediaStreamSource(s);
 var processor = audioContext.createScriptProcessor(2048, 1, 1);
 mediaStreamSource.connect(processor);
 processor.connect(audioContext.destination);
 processor.onaudioprocess = function (e) {
  var inputData = e.inputBuffer.getChannelData(0);
  var inputDataLength = inputData.length;
  var total = 0;
  for (var i = 0; i < inputDataLength; i++) {
      total += Math.abs(inputData[i++]);
  }
  var rms = Math.sqrt(total / inputDataLength);
  var perct=rms*100;
  $('#settings-mic-progress-icon').css('box-shadow', '0 0 '+perct+'px rgba(255,255,255,0.9)');
 };
}
var preview_video_stream=null;
var preview_audio_stream=null;
function playPreviewVideo(did) {
 const vdid = PERSISTENCE.get('vdid');
 if(vdid===did&&MEDIA.localstream) {
  $('#camera-dropdown').val(vdid);
  document.getElementById('settings-camera').srcObject=MEDIA.localstream;
 }
 else get_configured_media({
  video:{
   deviceId:{
    exact:[did]
   }
  }
 },function(e,s){
  if(e) return GUIUTIL.alert('error',e);
  $('#camera-dropdown').val(did);
  document.getElementById('settings-camera').srcObject=s;
  preview_video_stream=s;
 });
}

function checkMic(did) {
 const adid = PERSISTENCE.get('adid');
 if(adid===did&&MEDIA.localstream&&MEDIA.localstream.getAudioTracks().length) {
  $('#mic-dropdown').val(adid);
  audio_animation(MEDIA.localstream);
  document.getElementById('settings-camera').srcObject=MEDIA.localstream;
 }
 else get_configured_media({
  video:false,
  audio:{
   deviceId:{exact:[did]},
   advanced: [
    {
     googEchoCancellation: {exact: true}
    },
    {
     googExperimentalEchoCancellation: {exact: true}
    },
    {
     googAutoGainControl: {exact: true}
    },
    {
     googNoiseSuppression: {exact: true}
    },
    {
     googHighpassFilter: {exact: true}
    },
    {
     googAudioMirroring: {exact: true}
    }
   ]
  }
 },function(e,s){
  if(e) return L.error({err: e},"Failed to get user media"),GUIUTIL.alert('error',e);
  preview_audio_stream=s;
  audio_animation(s);
 });
}
function set_auto_res_label(res){
 if(!res) res=PERSISTENCE.get('sel_auto_res','1');//default 1: medium
 var type=CAMERA.auto_resolution_map[res];
 let r=CAMERA.auto_settings[type];
 $("#lbl_auto_res_status").html(
  `<div>${STRINGS.label_active}: ${CAMERA.tests[r.active.res].width}X${CAMERA.tests[r.active.res].height}, ${r.active.fps} fps</div>
   <div>${STRINGS.label_inactive}: ${(CAMERA.tests[r.active.res].width/2)}X${(CAMERA.tests[r.active.res].height/2)}, 1 fps</div>
   <div>${STRINGS.label_bandwidth}: &#8595; ${r.bw.dl} Mbps, &#8593; ${r.bw.ul} Mbps</div>
  `);
}
var selected_tab="btn_quality_auto";
var sel_active_res="QVGA";
export function openqualitytype(id,pp) {
 if(pp) {
  $(`#txt_maxdownload`).val(pp.maxdl);
  $(`#txt_maxupload`).val(pp.maxul);
  $('#active-sp-dropdown').val(pp.sel_active_res);
  $(`#txt_active_framerate`).val(pp.active_fr);
  $("#range_auto_quality").val(pp.sel_auto_res);
  set_auto_res_label();
 }

 if(id==="btn_quality_manual") {
  $("#panel_auto_quality").hide();
  $("#panel_manual_quality").show();
  $("#btn_quality_auto").removeClass('active');
  $("#btn_quality_manual").addClass('active');
 }
 else {
  $("#panel_manual_quality").hide();
  $("#panel_auto_quality").show();
  $("#btn_quality_manual").removeClass('active');
  $("#btn_quality_auto").addClass('active');
 }
 selected_tab=id;
}

export function onautoreschange() {
 set_auto_res_label($("#range_auto_quality").val());
}
export function onCameraSelect(did) {
 playPreviewVideo(did);
}
export function onMicSelect(did) {
 checkMic(did);
}
export function onSpeakerSelect(did) {
 alert(did);
}
export function onactivereschange(res) {
 sel_active_res=res;
}
export function onchange_bandwdith(b) {
 if(!Object.keys(PEER.connections).length) return L.error('No connections yet');
 $('#dd_bandwidth').attr('disabled',true);
 each(Object.values(PEER.connections),(pc,cb)=>BANDWIDTH.update_peer(pc,b,cb),(e)=>{
  if(e) L.error(e);
  $('#dd_bandwidth').attr('disabled',false);
  L.info(`New band width applied: ${b}`);
  PERSISTENCE.put('bandwidth',b);
 });
}

export function sendTextMessage(/*id*/) {
 var msg=document.getElementById("txt_chat_message").value;
 msg=msg.trim();
 if(msg!="") {
  Object.values(PEER.connections).forEach(pc=>{
   if(pc.data_channel.open) pc.data_channel.send(msg);
   else L.error({name: pc.name},`Failed to send message`);
  });
  msg=U.decorate_text(msg);
  var bubble = `
  <div class="chat_bubble" style="width:100%;">
   <div class="macro">
    <div class="text text-r">
     <div class="head-text">
      ${TODO.self_name||"unknown"}&nbsp;<small class="time-text"> ${UTIL.getTimestamp()}</small>
     </div>
     <div class="msg-text">${msg}</div>
    </div>
   </div>
  </div>`;
  $("#chat_history").append(bubble);
  $('#chat_history').scrollTop($('#chat_history')[0].scrollHeight);
 }
 document.getElementById("txt_chat_message").value="";
}

const grid = { a: 10, b: 6 };
var rows=grid.b;
var columns=grid.a;
var active_rows=grid.b;
var active_cols=grid.a;
var inactive_rows=1;
var inactive_cols=1;
var default_layout = [
 { "count": 1, "active": grid.a },
 { "count": 6, "active": grid.a-1 },
 { "count": 12, "active": grid.a-2 },
 { "count": 18, "active": grid.a-3 },
 { "count": 24, "active": grid.a-4 },
 { "count": 30, "active": grid.a-5 }];
var gallery_layout = [
 { "count": 1, "parts": { "a": 1, "b": 1 } },
 { "count": 2, "parts": { "a": 2, "b": 1 } },
 { "count": 4, "parts": { "a": 2, "b": 2 } },
 { "count": 6, "parts": { "a": 3, "b": 2 } },
 { "count": 9, "parts": { "a": 3, "b": 3 } },
 { "count": 15, "parts": { "a": 5, "b": 3 } },
 { "count": 30, "parts": { "a": 10, "b": 3 } }];

export function arrange_elements() {
 if(document.fullscreenElement) return;
 var elements=Object.values(PEER.connections).filter(pc=>{
  const valid=pc.isconnected&&pc.name;
  if(!valid) L.error({peer:pc},`Non connected or invalid peer found.`);
  return valid;
 }).sort((a,b)=>{
  if(a.name.toLowerCase()>b.name.toLowerCase()) return 1;
  else if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
  return 0;
 });
 elements.push({ "id": "self", "name": STRINGS.self_video_name, speaker: false });
 var avail_height=$("#participants_container").height();
 var avail_width=$("#participants_container").width();
 const ismobile=avail_height>avail_width;
 inactive_rows=1;
 inactive_cols=1;
 if(ismobile) {
  rows=10;
  columns=6;
  active_rows=10;
  active_cols=6;
 }
 else {
  rows=6;
  columns=10;
  active_rows=6;
  active_cols=10;
 }
 let layout = undefined;
 const grid_dim = {
  "x": $('#participants_container').width(),
  "y": $('#participants_container').height()
 };
 if(TODO.gallery) {
  active_rows=1;
  active_cols=1;
  layout = gallery_layout.find(function(l) { return elements.length <= l.count });
  const span_a = Math.floor(grid.a/layout.parts.a);
  const span_b = Math.floor(grid.b/layout.parts.b);
  active_rows=inactive_rows = ismobile?span_a:span_b;
  active_cols=inactive_cols = ismobile?span_b:span_a;
 }
 else {
  layout = default_layout.find(function(l) { return elements.length <= l.count });
  if(ismobile) active_rows = layout.active;
  else active_cols = layout.active;
 }
 $('#participants_container').css("grid-template-rows",`repeat(${rows}, 1fr)`);
 $('#participants_container').css("grid-template-columns",`repeat(${columns}, 1fr)`);
 if(elements.length==1) {
  L.trace(`Active speaker: ${elements[0].name}`);
  var elem = $(`#${elements[0].id}VP`);
  elem.css("grid-column",`1 / span ${active_cols}`);
  elem.css("grid-row",`1 / span ${active_rows}`);
  elem.css("margin","0px 0px");
  elem.css("box-shadow", "none");
 }
 else {
  var speaker=elements.find(item=>item.speaker);
  var r=1,c=TODO.gallery?1:(active_cols+1);
  if(ismobile) r=TODO.gallery?1:(active_rows+1),c=1;
  $('.participant_name').css('background','transparent');
  elements.forEach((item)=>{
   let item_span = { "cols": 0, "rows": 0 };
   let elem = $(`#${item.id}VP`);
   if(!speaker) speaker=elements[0];
   if((!TODO.gallery) && (speaker.id==item.id)) {
    L.trace(`Active speaker: ${item.name}`);
    elem.css("grid-column",`1 / span ${active_cols}`);
    elem.css("grid-row",`1 / span ${active_rows}`);
    elem.css("margin","0px 0px");
    elem.css("box-shadow", "none");
    item_span.cols = active_cols;
    item_span.rows = active_rows;
   }
   else {
    elem.css("grid-column",`${c} / span ${inactive_cols}`);
    elem.css("grid-row",`${r} / span ${inactive_rows}`);
    elem.css("box-shadow", (speaker.id==item.id)?"0px 0px 8px rgba(5,255,251,0.9)":"none");
    item_span.cols = inactive_cols;
    item_span.rows = inactive_rows;
    if(ismobile) {
     c+=inactive_cols;
     if((c+inactive_cols)>(columns+1)) {
      r+=inactive_rows,c=1;
     }
    }
    else {
     c+=inactive_cols;
     if((c+inactive_cols)>(columns+1)) {
      r+=inactive_rows,c=(TODO.gallery?1:(active_cols+1));
     }
    }
   }
   if(item.id != "self") {
    //console.log(grid_dim);
    //console.log(item_span);
    C2GSOCKET.c2gsocket.msg(
     { to:{user:item.id}, type:'dimension' },
     {
      x:(grid_dim.x*item_span.cols/columns),
      y:(grid_dim.y*item_span.rows/rows)
     }
    );
   }
  });
 }
}

var audioContext;
const fallbacks={active_res:320,active_fr:10};
export function open_stats() {
 const bchecked=PERSISTENCE.get('speaker_detection',true);
 if(!bchecked) return GUIUTIL.alert('error', STRINGS.alert_enable_active_speaker);
 if(!Object.keys(PEER.connections).length) return L.error('No peers connected to show stats');
 $("#btn_stats").toggleClass("wtg-green");
 $("#btn_stats").toggleClass("wtg-red");
 if(STATS.is_on)
  STATS.is_on=false,$(`.statscontainer`).hide();
 else
  STATS.is_on=true,$(`.statscontainer`).show();
 let tooltip = STRINGS[TODO.tips.btn_stats[+STATS.is_on]];
 $("#btn_stats").attr('title', tooltip).tooltip('fixTitle').tooltip('show');
}
export function openSettings() {
 $('#settings-panel-parent').toggle();
 $("#btn_settings").toggleClass("wtg-green");
 $("#btn_settings").toggleClass("wtg-red");
 if($('#settings-panel-parent').css('display')=='none'){
  if(audioContext) audioContext.close().then(function() {
   audioContext=null;
  });
  return;
 } 
 if(!(navigator&&navigator.mediaDevices))
  return L.error({useragent: navigator.userAgent},"Incompatible browser"),
  GUIUTIL.alert('error', STRINGS.alert_browser_not_compatible);
 const lang=PERSISTENCE.get('lang');
 $('#language-dropdown').val(lang?lang:"en");
 $('#camera-dropdown')
    .empty()
    .append('<option selected="selected" value="-1">Detected camera devices list</option>');
 $('#mic-dropdown')
  .empty()
  .append('<option selected="selected" value="-1">Detected Microphone devices list</option>');
 list_media_devices((e,r)=>{
  if(e) return L.error(e),GUIUTIL.alert('error',e);
  $('#camera-dropdown').empty().append(Object.values(r.videoinput||{}).map(x=>new Option(x.label,x.deviceId)));
  $('#mic-dropdown').empty().append(Object.values(r.audioinput||{}).map(x=>new Option(x.label,x.deviceId)));
  if(r.videoinput) {
   const vdid=PERSISTENCE.get('vdid');
   playPreviewVideo((r.videoinput[vdid])?vdid:Object.keys(r.videoinput)[0]);
  }
  else L.error('No video devices?');
  if(r.audioinput) {
   const adid=PERSISTENCE.get('adid');
   checkMic(r.audioinput[adid]?adid:Object.keys(r.audioinput)[0]);
  }
 });
 
 //resolution dropdowns
 $('#active-sp-dropdown').empty()
 .append(Object.keys(CAMERA.tests)
 .filter(k=>!!CAMERA.tests[k].result)
 .map(k=>new Option(`${k}- ${CAMERA.tests[k].width}X${CAMERA.tests[k].height}`,k)));
 
 //set selected tab
 var sel_tab=PERSISTENCE.get(`sel_tab`,'btn_quality_auto');
 openqualitytype(
  sel_tab,
  PERSISTENCE.get({
   sel_auto_res: '1',
   maxdl: BANDWIDTH.max_download,
   maxul: BANDWIDTH.max_upload,
   sel_active_res,active_fr: fallbacks.active_fr
  })
 );

}
export function applySettings() {
 PERSISTENCE.put({
  vdid: $( "#camera-dropdown option:selected").val(),
  adid: $( "#mic-dropdown option:selected").val(),
  active_res: sel_active_res,
  active_fr: +$("#txt_active_framerate").val()||fallbacks.active_fr,
  maxdl: +$("#txt_maxdownload").val()||BANDWIDTH.max_download,
  maxul: +$("#txt_maxupload").val()||BANDWIDTH.max_upload,
  sel_tab: selected_tab,
  sel_auto_res: +$("#range_auto_quality").val(),
  lang: $( "#language-dropdown option:selected").val()
 });
 location.reload();
}
export function cancelSettings() {
 if(audioContext) audioContext.close().then(function() {
  audioContext=null;
 });
 preview_audio_stream&&preview_audio_stream.getTracks().forEach((t)=>{t.stop()});
 preview_video_stream&&preview_video_stream.getTracks().forEach((t)=>{t.stop()});
 $("#settings-panel-parent").toggle();
 $("#btn_settings").toggleClass("wtg-green");
 $("#btn_settings").toggleClass("wtg-red");
}

$("#chkb_active_participant").change(function() {
 PERSISTENCE.put('speaker_detection',+this.checked);
});

export function start_text_animation() {
 /** animate welcome screen text */
 eachSeries(['secure','simple','unlimited'],function(x,cb) {
  $('#marketing_'+x).css('opacity',1);
  const element = $('#'+x+'_text');
  const text = element.html();
  element.html("");
  eachSeries(text.split(''),function(x,cb) {
   element.append(x);
   setTimeout(cb,40);
  },cb);
 },function() { L.trace('Text animation done') });
}
/* vim:set ts=8 sw=1 expandtab: */
